
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement(
		"g",
		{ fill: "#ddd" },
		React.createElement("path", { d: "m26.5 42.6l-5.7-5.2c0 0-6.3 6.4-8.1 6.7-2 .2-5.9-2.1-9.1 1.1-2.2 2.2-2.2 5.8 0 8 1.5 1.5 3.8 2 5.7 1.4-.6 1.9-.1 4.2 1.4 5.7 2.2 2.2 5.8 2.2 8 0 3.2-3.2.8-7.1 1.1-9.1 0-2.2 6.7-8.6 6.7-8.6" }),
		React.createElement("path", { d: "m42.6 26.5l-5.2-5.7c0 0 6.4-6.3 6.7-8.1.2-2-2.1-5.9 1.1-9.1 2.2-2.2 5.8-2.2 8 0 1.5 1.5 2 3.8 1.4 5.7 1.9-.6 4.2-.1 5.7 1.4 2.2 2.2 2.2 5.8 0 8-3.2 3.2-7.1.8-9.1 1.1-2.2 0-8.6 6.7-8.6 6.7" })
	),
	React.createElement("path", { d: "m31.9 10.6c-3.2.8-20.5 18.1-21.2 21.2-1.2 4.9 16.6 22.7 21.5 21.5 3.1-.8 20.5-18.1 21.2-21.2 1.2-4.9-16.6-22.7-21.5-21.5", fill: "#a86332" }),
	React.createElement(
		"g",
		{ fill: "#e6b858" },
		React.createElement("path", { d: "m14.6 31.9l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m17.9 33.3l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m36.9 19.1h1.4v1.4h-1.4z", transform: "matrix(.7071-.7071.7071.7071-2.9902 32.4005)" })
	),
	React.createElement("path", { d: "m33.3 14.1h2.1v2.1h-2.1z", fill: "#e6d0a3", transform: "matrix(.7072-.707.707.7072-.6649 28.7401)" }),
	React.createElement("path", { d: "m32.4 18.3h1.4v1.4h-1.4z", fill: "#e6b858", transform: "matrix(.7073-.7069.7069.7073-3.7809 28.9561)" }),
	React.createElement(
		"g",
		{ fill: "#e6d0a3" },
		React.createElement("path", { d: "m31.2 13h1.4v1.4h-1.4z", transform: "matrix(.7071-.7071.7071.7071-.334 26.5385)" }),
		React.createElement("path", { d: "m21.3 23.8h1.4v1.4h-1.4z", transform: "matrix(.7073-.7069.7069.7073-10.8884 22.7414)" })
	),
	React.createElement(
		"g",
		{ fill: "#e6b858" },
		React.createElement("path", { d: "m24.5 27.6h2.1v2.1h-2.1z", transform: "matrix(.7071-.7071.7071.7071-12.7901 26.4372)" }),
		React.createElement("path", { d: "m27.3 29.5h1.4v1.4h-1.4z", transform: "matrix(.7073-.7069.7069.7073-13.1185 28.6322)" })
	),
	React.createElement(
		"g",
		{ fill: "#804c26" },
		React.createElement("path", { d: "m44.2 38.8l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m40.9 40.1l-1.5 1.5 1.5 1.5 1.5-1.5-1.5-1.5" }),
		React.createElement("path", { d: "m39.2 36.1l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m30.8 47.4l-1.5 1.5 1.5 1.5 1.5-1.5-1.5-1.5" }),
		React.createElement("path", { d: "m28.5 42.9l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m27.9 46.4l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m47.5 29.2l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m50.6 29.9l-1 1 1 1 1-1-1-1" }),
		React.createElement("path", { d: "m42.9 35.6l-1 1 1 1 1-1-1-1" })
	),
	React.createElement(
		"g",
		{ fill: "#e6b858" },
		React.createElement("path", { d: "m49.8 37.5l-26.9-19.7 1.6-1.6 26.2 20.4z" }),
		React.createElement("path", { d: "m37.4 49.7l-23-23 .7-.9 23.9 22.7z" })
	),
	React.createElement(
		"g",
		{ fill: "#804c26" },
		React.createElement("path", { d: "m38.8 48.9l-24-23 .8-.8 25.9 20.7z" }),
		React.createElement("path", { d: "M49.2 38.1 20.7 19.4 23.1 17 50.2 37.5z" })
	),
	React.createElement(
		"g",
		{ fill: "#fff" },
		React.createElement("path", { d: "m11.6 59.8c-.6-3 .6-5.9 2.8-7.6-.1 0-.1 0-.2 0-2.5.5-4.1 3-3.6 5.6.2.9.6 1.6 1.1 2.3 0-.1 0-.2-.1-.3", opacity: ".4" }),
		React.createElement("path", { d: "m4 50.9c-.4-2.2.4-4.2 2-5.5 0 0-.1 0-.1 0-1.8.4-3 2.2-2.6 4 .1.6.4 1.2.8 1.6-.1 0-.1 0-.1-.1", opacity: ".4" }),
		React.createElement("path", { d: "m59.8 11.4c-3-.6-5.9.6-7.6 2.8 0-.1 0-.1 0-.2.5-2.5 3-4.1 5.6-3.6.9.2 1.6.6 2.3 1.1-.1 0-.2-.1-.3-.1", opacity: ".4" }),
		React.createElement("path", { d: "m50.9 3.7c-2.2-.4-4.2.4-5.5 2 0 0 0-.1 0-.1.3-1.8 2.2-3 4-2.6.6.1 1.2.4 1.6.8.1 0 0-.1-.1-.1", opacity: ".4" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/meat_on_bone.js
// module id = 711
// module chunks = 0